import React from "react";
import { scrollToBottom, useSync } from "@hex-insights/core";
import { ValidationDisplayPolicy } from "@hex-insights/forms";
import { MessageGroup } from "../../../../../Utilities";
import { MessageCustomForm } from "../../../../Forms";
import { MessageGroupUtilities } from "../../../../Utilities";
import styles from "./styles.module.css";

const messageFormStateArgs = {
	validationDisplayPolicy: ValidationDisplayPolicy.none,
};

export type FooterProps = {
	messageGroupID: MessageGroup["id"];
	onSuccess: () => void;
	dragStartElementRef: React.MutableRefObject<HTMLDivElement | null>;
};

export function Footer({ messageGroupID, onSuccess: onSuccessProp, dragStartElementRef }: FooterProps) {
	const { syncID, synchronize } = useSync();

	const evictLatestMessagesCache = MessageGroupUtilities.useEvictLastestMessagesCache();
	const onSuccess = React.useCallback(() => {
		synchronize();
		onSuccessProp();
		evictLatestMessagesCache();
	}, [synchronize, onSuccessProp, evictLatestMessagesCache]);

	const { canSendMessage } = MessageGroupUtilities.useCanViewerSendMessageInGroup(messageGroupID);
	if (!canSendMessage) {
		return null;
	}

	return (
		<MessageCustomForm.ControlledCreateOnMessageGroup
			key={syncID}
			formStateArgs={messageFormStateArgs}
			messageGroupID={messageGroupID}
			onSuccess={onSuccess}
			noNotifications
			noNavigationPrompt
			mergeUnsavedChangesAutomatically
			formNameSuffix={messageGroupID}
			className={styles["footer__message-form"]}
			bodyAreaClassName={styles["footer__message-form__body-area"]}
			fileDropAreaClassName={styles["footer__message-form__file-drop-area"]}
			dragStartElementRef={dragStartElementRef}
			onAddMediaAttachment={scrollToBottom}
		/>
	);
}
